import { render, staticRenderFns } from "./productformtab.vue?vue&type=template&id=8bd52f1e&scoped=true"
import script from "./productformtab.vue?vue&type=script&lang=js"
export * from "./productformtab.vue?vue&type=script&lang=js"
import style0 from "./productformtab.vue?vue&type=style&index=0&id=8bd52f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd52f1e",
  null
  
)

export default component.exports